import { Box, InputAdornment, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import IInputFieldProps from "../../interfaces/IInputFIeldProps";
import { colors } from "../../../ui/colors";

export const InputField: React.FC<IInputFieldProps> = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  extraType,
  width = "100%",
  onKeyDown,
  inputProps,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box sx={{ width: width }}>
      {label && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mb: 0.5,
            fontWeight: 600,
            color: "var(--fx-surface-textsecondary, #64748B)",
            textTransform: "uppercase",
            fontSize: "10px",
          }}
        >
          {label}
        </Typography>
      )}

      <TextField
        value={value}
        type={type}
        size="small"
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={onKeyDown}
        inputProps={inputProps}
        sx={{
          width: extraType ? "75px" : isMobile ? "120px" : "200px",
          "& .MuiOutlinedInput-root": {
            height: 36,
            borderRadius: "8px",
            backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
            transition: "all 0.2s",
            "&:hover": {
              backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--fx-surface-borderstrong, #CBD5E1)",
              },
            },

            "&.Mui-focused": {
              backgroundColor: "var(--fx-surface-base, #FFFFFF)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.orange.base,
                borderWidth: "1px",
              },
            },
          },
          "& .MuiOutlinedInput-input": {
            padding: "0 10px",
            fontSize: 12,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--fx-surface-border, #E2E8F0)",
            transition: "border-color 0.2s",
          },
        }}
      />
    </Box>
  );
};
export default InputField;
